import type { ReportConfigurationLookupOption } from "../types";
import { ValuePicker } from "./ValuePicker";

interface SelectPickerProps {
    ariaLabel?: string;
    options: ReportConfigurationLookupOption[];
    optionGroupLabels?: Record<string, string>;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    searchPlaceholder?: string;
    disabled?: boolean;
    searchable?: boolean;
    searchThreshold?: number;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}

export function SelectPicker({
    ariaLabel,
    options,
    optionGroupLabels,
    value,
    onChange,
    placeholder = "Select...",
    searchPlaceholder = "Search...",
    disabled,
    searchable,
    searchThreshold,
    open,
    onOpenChange,
}: SelectPickerProps) {
    const selected = options.find((option) => option.value === value);
    return (
        <ValuePicker
            ariaLabel={ariaLabel}
            mode="select"
            options={options}
            optionGroupLabels={optionGroupLabels}
            placeholder={selected?.name || placeholder}
            searchPlaceholder={searchPlaceholder}
            onPick={onChange}
            disabled={disabled}
            searchable={searchable}
            searchThreshold={searchThreshold}
            open={open}
            onOpenChange={onOpenChange}
        />
    );
}
